import React from 'react';
import './ScrollIndicator.css';

const ScrollIndicator = () => {
  const scrollToContent = () => {
    const scrollContent = document.querySelector('.scroll-content');
    if (scrollContent) {
      scrollContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="scroll-indicator" onClick={scrollToContent}>
      <svg width="64" height="48" viewBox="0 0 64 48" aria-hidden="true">
        <polygon points="32,38 12,18 52,18" fill="#fff" />
      </svg>
    </div>
  );
};

export default ScrollIndicator;